import React from 'react';
import { useNavigate, useLocation, Routes, Route, Navigate } from 'react-router-dom';
import { Dumbbell, User } from 'lucide-react';

import { auth } from '../../firebase';

import Profile from '../custom/Profile';
import Workouts from '../custom/Workouts';
import WorkoutDetail from '../custom/WorkoutDetail';
import ExerciseTracking from '../custom/ExerciseTracking';

const AppContent: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const user = auth.currentUser;

  const handleMenuClick = (route: string) => {
    navigate(route);
  };

  const isActive = (route: string) => location.pathname.startsWith(route);

  // Hide tab bar on detail pages
  const showTabBar = location.pathname === '/workouts' || location.pathname === '/profile';

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Routes>
        <Route path="/" element={<Navigate to="/workouts" replace />} />
        <Route path="/profile" element={<Profile id={user?.uid} />} />
        <Route path="/workouts" element={<Workouts />} />
        <Route path="/workouts/:workoutID" element={<WorkoutDetail />} />
        <Route path="/workouts/:workoutID/exercise/:exerciseID" element={<ExerciseTracking />} />
      </Routes>

      {/* Tab Bar - iOS Liquid Glass Style */}
      {showTabBar && (
        <div className="fixed bottom-0 left-0 right-0 px-4 pb-6 pt-2">
          <div className="flex items-center justify-around h-14 rounded-[28px] shadow-[0_4px_16px_rgba(0,0,0,0.12)] px-1.5 bg-white dark:bg-[hsl(240_5%_16%)]">
            <button
              onClick={() => handleMenuClick('/workouts')}
              className="flex flex-col items-center justify-center gap-0.5 flex-1 h-11 rounded-[22px] transition-colors"
              style={isActive('/workouts') ? { backgroundColor: 'hsl(var(--tmw-accent))', color: 'white' } : { color: 'hsl(0 0% 45%)' }}
            >
              <Dumbbell className="h-5 w-5" />
              <span className="text-[10px] font-semibold">Workouts</span>
            </button>

            <button
              onClick={() => handleMenuClick('/profile')}
              className="flex flex-col items-center justify-center gap-0.5 flex-1 h-11 rounded-[22px] transition-colors"
              style={isActive('/profile') ? { backgroundColor: 'hsl(var(--tmw-accent))', color: 'white' } : { color: 'hsl(0 0% 45%)' }}
            >
              <User className="h-5 w-5" />
              <span className="text-[10px] font-medium">Profile</span>
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default AppContent;
